import { useEffect, useState } from "react";
import { Box, Checkbox, DataGrid, Grid, TextField } from "../../../../components";
import '../../addProduto/produto.css';
import { gridClasses } from "@mui/x-data-grid";
import { formatPrice } from "../../../../utils";

const GridProdutosStep = ({
  produtos,
  setProdutos,
  inputErros
}) => {

  const [selecionadoTodos, setSelecionadoTodos] = useState(false);

  const colunasProdutos = [
    {
      field: "checked",
      sortable: false,
      flex: 30,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
          <Checkbox
            checked={selecionadoTodos}
            onChange={onClickCheckboxTodos}
          />
      ),
      renderCell: (params) => (
        <Checkbox
          checked={params.row.checked}
          onChange={(event) => onClickCheckbox(event, params.row.id)}
        />
      ),
    },
    {
      field: "codigo",
      headerName: "Código",
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      flex: 40,
    },
    {
      field: "descricao",
      headerName: "Produto",
      sortable: false,
      flex: 400,
    },
    {
      field: "codigoBarra",
      headerName: "Código Barra",
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      flex: 80,
    },
    {
      field: "precoVenda",
      headerName: "Preço de Venda",
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      flex: 80,
      renderCell: (params) => formatPrice(params.value),
    },
    {
      field: "quantidade",
      headerName: "Quantidade",
      flex: 60,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      renderCell: (params) => renderCellInputQuantidade(params),
    },
  ];
  
  const renderCellInputQuantidade = (params) => {
    return (
      params.row.checked &&
      <div key={params.row.id}>
        <TextField
          id="quantidade"
          name="quantidade"
          type="text"
          variant="standard"
          value={params.value}
          fullWidth
          onChange={(event) => 
            handleNumericInputChange(params.row.id, event)
          }
          InputProps={{
            disableUnderline: true,
            endAdornment: (
              <i className="ph-fill ph-pencil" style={{ marginRight: -4, marginLeft: 10, fontSize: 18 }}></i>
            ),
            sx: {
              '& input': {
                fontFamily: "'Montserrat', sans-serif !important",
                fontSize: '16px',
                textAlign: 'right',
              },
            }
          }}
        />
      </div>
    )
  };

  function erroCelulaGridProdutos(params, inputErros) {
    if (!inputErros || !params) return "";
    const indiceItem = params.api.getRowIndexRelativeToVisibleRows(params.row.id);
    return inputErros.get(`[${indiceItem}].${params.field}`);
  }
  
  useEffect(() => {
    handleSelecaoTodosProdutos(produtos);
  }, []);

  const handleSelecaoTodosProdutos = (produtos) => {
    const produtosNaoSelecionados = produtos.filter(({checked}) => !checked).length;
    setSelecionadoTodos(!produtosNaoSelecionados);
  }

  const onClickCheckboxTodos = () => {
    setProdutos((prevState) => prevState.map((prod) => ({
      ...prod,
      checked: !selecionadoTodos
    })));
    setSelecionadoTodos((prevState) => !prevState);
  }

  const handleNumericInputChange = (id, event) => {
    const { name, value } = event.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setProdutos((prevState) => prevState.map((produto) => 
      id === produto.id 
        ? { ...produto, [name]: numericValue } 
        : produto
    ));
  }

  const onClickCheckbox = (event, id) => {
    const produtosAtualizados = produtos.map((prod) =>
      prod.id === id ? { ...prod, checked: event.target.checked } : prod
    );
    setProdutos(produtosAtualizados);

    handleSelecaoTodosProdutos(produtosAtualizados);
  };

  return (
    <>
      <Grid container spacing={2} sx={{ pl: 2, mt: 3 }}>
        <Box
          sx={{
            width: '100%',
            [`.${gridClasses.cell}.warning`]: {
              border: '2px solid #f00',
            },
          }}
        >
        <DataGrid
          rows={produtos || []}
          columns={colunasProdutos}
          rowCount={produtos?.length || 0}
          disableAcoes
          getCellClassName={(params) => {
            const error = erroCelulaGridProdutos(params, inputErros);
            if (params.field === 'quantidade' && error) {
              return 'warning';
            }
            return '';
          }}
        />
        </Box>
      </Grid>
    </>
  );
};

export default GridProdutosStep;
